import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private static readonly ACCESS_TOKEN_KEY = 'access_token';

  getAccessToken(): string | null {
    return localStorage.getItem(TokenService.ACCESS_TOKEN_KEY);
  }

  setAccessToken(token: string): void {
    localStorage.setItem(TokenService.ACCESS_TOKEN_KEY, token);
  }

  removeAccessToken(): void {
    localStorage.removeItem(TokenService.ACCESS_TOKEN_KEY);
  }

  hasAccessToken(): boolean {
    return this.getAccessToken() !== null;
  }

  isAccessTokenExpired(): boolean {
    const token = this.getAccessToken();
    if (!token) {
      return true;
    }
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      // 60-second buffer for clock skew
      return Date.now() >= payload.exp * 1000 - 60_000;
    } catch {
      return true;
    }
  }
}
